
import { Drawer, Input } from "element-ui"
import _ from "lodash"
import drawerHeader from "./components/drawerHeader.vue"
import collapseTransition from "@/library/collapse-transition.js"
import { validatePhoneNumber } from "@/utils/auth"
export default {
  name: "EditRecipient",
  components: {
    [Drawer.name]: Drawer,
    [Input.name]: Input,
    collapseTransition,
    drawerHeader
  },
  directives: {
    "click-outside": {
      inserted: function (el, binding, vnode) {
        const parentEl = document.getElementById("edit-recipient-item-select")
        el.event = function (event) {
          if (!(el === event.target || el.contains(event.target)) && !(parentEl && parentEl.contains(event.target))) {
            if (typeof vnode.context[binding.expression] === "function") {
              vnode.context[binding.expression](event)
            }
          }
        }
        document.body.addEventListener("click", el.event, true)
      },
      unbind: function (el) {
        document.body.removeEventListener("click", el.event, true)
      }
    }
  },
  props: {
    shipmentType: {
      type: Number,
      default: 0,
      require: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    recipientInfo: {
      type: Object,
      default: () => {}
    },
    saveAutoClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      curVisible: this.visible,
      curRecipientInfo: {},
      oldRecipientInfo: {},
      codeOptions: [
        {
          value: "+852",
          label: "+852"
        },
        {
          value: "+853",
          label: "+853"
        },
        {
          value: "+86",
          label: "+86"
        }
      ],
      codeListShow: false,
      invalid: false,
      invalidText: ""
    }
  },
  computed: {
    isSaveDisabled() {
      const { name, code, num, email } = this.curRecipientInfo
      const { name: oldName, code: oldCode, num: oldNum, email: oldEmail } = this.oldRecipientInfo
      if (this.invalid) {
        return true
      }
      if (!name || !code || !num || !email) {
        return true
      }
      if (
        name &&
        oldName &&
        name === oldName &&
        code &&
        oldCode &&
        code === oldCode &&
        num &&
        oldNum &&
        num === oldNum &&
        email &&
        oldEmail &&
        email === oldEmail
      ) {
        return true
      }
      return false
    }
  },
  watch: {
    visible(val) {
      this.curVisible = val
      if (val) {
        this.resetInvalidNotice()
        this.curRecipientInfo = _.cloneDeep(this.recipientInfo)
        this.oldRecipientInfo = _.cloneDeep(this.recipientInfo)
      }
    }
  },
  methods: {
    resetInvalidNotice() {
      this.invalid = false
      this.invalidText = ""
    },
    hideCodeList() {
      this.codeListShow = false
    },
    toggleCodeListShow() {
      this.codeListShow = !this.codeListShow
    },
    handleSelect(item) {
      if (this.curRecipientInfo.code !== item.value) {
        this.curRecipientInfo.code = item.value
        this.checkInput()
      }
      this.hideCodeList()
    },
    handleInput(value) {
      // 限制输入数字
      this.curRecipientInfo.num = value.replace(/[^\d]/g, "")

      this.$nextTick(() => {
        this.checkInput()
      })
    },
    checkInput() {
      const { code, num } = this.curRecipientInfo
      const phoneValue = code + " " + num
      if (!validatePhoneNumber(phoneValue)) {
        this.invalid = true
        if (code === "+86") {
          this.invalidText = this.$t("cart.recipientWarningTextWith11Digits")
        } else {
          this.invalidText = this.$t("cart.recipientWarningTextWith8Digits")
        }
      } else {
        this.resetInvalidNotice()
      }
    },
    handleClose() {
      this.$emit("close")
    },
    /**
     * 校验邮箱格式是否合法
     * @param {string} email - 待校验的邮箱地址
     * @returns {boolean} - 返回 true 表示合法，false 表示非法
     */
    isValidEmail(email) {
      // 常见邮箱正则表达式（支持大多数邮箱格式）
      const emailRegex = /^[A-Za-z0-9_+\-._!#$%&'*/=?^{}~]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/

      // 1. 检查是否为空
      if (!email || typeof email !== "string") {
        return false
      }

      // 2. 去除首尾空格后校验
      const trimmedEmail = email.trim()
      return emailRegex.test(trimmedEmail)
    },
    handleSave() {
      if (!this.isValidEmail(this.curRecipientInfo.email)) {
        this.$message({
          message: this.$t("cart.emailMessae"),
          type: "warning"
        })
        return
      }
      this.$emit("save", this.curRecipientInfo)
      if (this.saveAutoClose) {
        this.handleClose()
      }
    }
  }
}
